import useIsSwissGeolocation from '@hooks/useIsSwissGeolocation'
import { VideoWidgetAPIProps } from '@widgets/Video/types'

type UseIsVideoGeoblockedType = (
  geoblocking?: VideoWidgetAPIProps['geoblocking'],
) => boolean

const getIsGeoblocked = (
  geoblockingValue: Parameters<UseIsVideoGeoblockedType>[0],
) => geoblockingValue === 'block_all_except_switzerland'

const useIsVideoGeoblocked: UseIsVideoGeoblockedType = (geoblocking) =>
  !useIsSwissGeolocation() && getIsGeoblocked(geoblocking)

export default useIsVideoGeoblocked
